/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import DoctorProfileForm from './doctor/ConsultantProfileForm.js';
import api, { API_URL, AuthProvider } from './util/api.js';
import Register from './pages/register.js';
/*  import RoleSelection from './pages/select_role.js';
import ConsultantProfileForm from './doctor/ConsultantProfileForm.js';
import DoctorDashboard from './doctor/DoctorDashboard.js'; */
/* import Footer from './footer.js';  */
/* import Header from './header.js'; */

import DoctorsDashboard from './doctor/dashboard.js';
import Home from './home.js';
import Login from './pages/login.js';
import DoctorChatBox from './chat/chatBox.js';
import DoctorChat from './doctor/DoctorChat.js';
import SelectRolePage from './pages/selectRole.js';
import DoctorProfile from './components/doctorprofile.js';
import ScrollToTop from './components/ScrollTop.js';
import AppointmentInteractionPage from './patients/appointment_details.js';

import PaymentPage from './components/payment_options.js';
import PatientForm from './patients/patientForm.js';
import PatientDashboard from './patients/dashboard.js';
import Doctors from './doctors.js';
import DocOngoingAppoint from './doctor/ongoingappoinments.js';
import DocCompletedAppoint from './doctor/completedappointments.js';
import DocAppointments from './doctor/doctorappointment.js';
import Transactions from './transactions.js';
import PatientOngoingAppointments from './patients/appointments.js';
import PatientAppointments from './patients/appointments.js';
import ConsultationCompletion from './doctor/consultation_completion.js';
import ConsultationReadOnly from './doctor/consultation_read_only.js';
import ConsultationHistory from './patients/consultation_history.js';
import BitcoinDepositPage from './components/crypto_payment/BitcoinPayment.js';
import AdminChatLauncher from './pages/chat/adminchatbox.js';
import ProvideEmail from './forgot/forgot.js';
import ChangePassword from './forgot/change_password.js';
import NotificationPage from './pages/Notification.js';
/* import TermsAndConditions from './pages/termsconditions.js'; */
import AboutUs from './pages/aboutus.js';
import useLogoutSync from './components/checklogout.js';
import useUserPresence from './components/useUserPresence.js';
import AdminLogin from './pages/adminLogin.js';
import VideoCallPage from './chat/VideoCallPage.js';
import PaymentDetails from './PaymentDetails.js';
import WithdrawHistory from './withdraw_history.blade.js';
import TotalcareTerms from './terms/TotalcareTerms.js';






function App() {

  useLogoutSync();
  useUserPresence();
  const path = window.location.pathname;
  const hideChat = path === '/login' || path === '/register';

     async function checkversion() {

        const version = await api.get(API_URL+`/version`);
        const getv = version.data;

        const savedVersion = localStorage.getItem('app_version1');
        if (savedVersion !== getv.version) {

            localStorage.setItem('app_version1', getv.version);
            window.location.reload(true); // hard refresh
            
        } else {
            localStorage.setItem('app_version1', getv.version);

        }


    }


    useEffect(()=>{
        checkversion() ;

    },[]);

  return (
    <>

      <BrowserRouter>

        <AuthProvider>

          {/*   <Header/> */}
          <ScrollToTop />


          <Routes>
            <Route path='/' element={<Home />} />



            <Route path='/register' element={<Register />} />
            <Route path='/login' element={<Login />} />
            <Route path='/admin_login' element={<AdminLogin />} />
            


            {/* patient Routes  */}

            <Route path="/patient-dashboard" element={<PatientDashboard />} />
            <Route path="/patient-reg" element={<PatientForm />} />
            <Route path="/patient-ongoing-appointments" element={<PatientAppointments title='Ongoing Appointments' link='/patient-ongoing-appointments' />} />
            <Route path="/patient-completed-appointments" element={<PatientAppointments title='Completed Appointments' link='/patient-completed-appointments' />} />
            <Route path="/all-appointments" element={<PatientAppointments title='All Appointment' link='/all-appointments' />} />
            {/* general auth routes  */}

            <Route path="/chatbox" element={<DoctorChat />} />
            <Route path="/video-call/:id" element={<VideoCallPage />} />
            
            <Route path="/select-role" element={<SelectRolePage />} />
            <Route path="/doctor-profile/:id" element={<DoctorProfile />} />
            <Route path="/appointment/:id" element={<AppointmentInteractionPage />} />
            

            <Route path="/payment_options/:appointment_id" element={<PaymentPage />} />

            <Route path="crypto_payment/:currency/:appointment_id" element={<BitcoinDepositPage />} />
            <Route   path="/payment_details" element={<PaymentDetails />} />


            <Route path="/doctors" element={<Doctors />} />

            {/* doctors  routes */}
            <Route path="/doctor-profile-reg" element={<DoctorProfileForm />} />
            <Route path="/doctor-dashboard" element={<DoctorsDashboard />} />
            <Route path="/doctor-ongoing-appointments" element={<DocOngoingAppoint />} />
            <Route path="/doctor-completed-appointments" element={<DocCompletedAppoint />} />
            <Route path="/doctor-doctor-appointments" element={<DocAppointments />} />


            {/* both patient and doctor routes  */}

            <Route path="/transactions" element={<Transactions />} />
            <Route  path="/withdraw-history" element={<WithdrawHistory />} />

            <Route path="/complete_consultation/:appointment_id" element={<ConsultationCompletion />} />
            <Route path="/consultation/:id" element={<ConsultationReadOnly />} />
            <Route path="/consultation-history/:id" element={<ConsultationHistory />} />
            <Route path="/notifications" element={<NotificationPage />} />

            <Route path="/forgot-password" element={<ProvideEmail />} />
            <Route path="/change_password" element={<ChangePassword />} />
            <Route path="/terms-and-conditions" element={<TotalcareTerms   />} />
            <Route path="/about-us" element={<AboutUs />} />









          </Routes>




          {/*  <Footer/> */}
          {!hideChat && (
            <div style={{ backgroundColor: "red", position: "relative" }}>

              <AdminChatLauncher />

            </div>

          )}


        </AuthProvider>
      </BrowserRouter>

    </>
  )
}

export default App
